import {z as zod} from "zod";

export type EventContainerAndEventOrchestrationWorkspaceCapabilityConfiguration = Record<string, never>;

export const eventContainerAndEventOrchestrationWorkspaceCapabilityConfigurationValidator: zod.ZodType<EventContainerAndEventOrchestrationWorkspaceCapabilityConfiguration> =
    zod.strictObject({});
